import store from "@/store/store";

let loadingRequests = 0
let loadingTimer = 0

function showLoading () {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    loadingRequests = loadingRequests + 1
    clearTimeout(loadingTimer)

    appLoading.classList.remove('in-active')
    appLoading.style.display = 'block'

    setTimeout(() => {
      appLoading.classList.add('active')
    }, 10)
  }
}

function hideLoading (force = false) {
  if (loadingRequests > 0) {
    loadingRequests = loadingRequests - 1
  }
  clearTimeout(loadingTimer)
  loadingTimer = setTimeout(() => {
    if (loadingRequests <= 0 || force) {
      const appLoading = document.getElementById('loading-bg')
      if (appLoading) {
        appLoading.classList.remove('active')
        appLoading.classList.add('in-active')

        setTimeout(() => {
          if (store.state.helper.requestStatus.length === 0 || force) {
            appLoading.style.display = 'none'
          }
        }, 10)
      }
    }
  }, 200)
}

export const loading = {
  show: showLoading,
  hide: hideLoading
}
